import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { ViewModes } from 'types/ViewModes';

import AdViewFrame from './AdViewFrame';
import AdViewToolbar from './AdViewToolbar/AdViewToolbar';

// TODO: should be done responsively
export type CreativeAdViewVariant = 'desktop' | 'mobile';

const Container = styled.div<{ $variant: CreativeAdViewVariant }>`
  border-right: 1px solid #f2ebeb;
  display: grid;
  height: 100%;

  grid-template-rows: ${(p) =>
    p.$variant === 'mobile' ? '60px 1fr' : '50px 1fr'};
`;

export interface CreativeAdViewProps {
  variant?: CreativeAdViewVariant;
}

function AdView({ variant }: CreativeAdViewProps) {
  const store_tearsheet = store.tearsheet;
  const ad = store_tearsheet?.ads.current;
  const viewScale = store_tearsheet?.viewScale ?? 1;

  return store.ui.viewMode === ViewModes.FRAMELESS ? (
    <AdViewFrame ad={ad} viewScale={viewScale} />
  ) : (
    <Container $variant={variant || 'desktop'}>
      <AdViewToolbar />
      <AdViewFrame ad={ad} viewScale={viewScale} />
    </Container>
  );
}

export default observer(AdView);
